var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProformaInvoicesReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M154.83 124.79v16.33H44.47v-16.33M154.83 124.79V77.62L137.3 65.36M61.32 65.83L44.47 77.62v47.17M61.32 89.26V56.51M137.29 89.55V65.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M154.83 77.62L137.3 89.55l-16.1 10.93-.95.65-14.52 9.87-5.86 3.99-.64.43-2.47-1.7-3.93-2.72-4.14-2.86-7.9-5.45-2.23-1.54-17.24-11.89-16.85-11.64M154.83 124.79v16.33H44.47v-16.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M154.83 124.79V77.62L137.3 65.36M61.32 65.83L44.47 77.62v47.17M61.32 89.26V56.51M137.29 89.55V65.36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M154.83 77.62L137.3 89.55l-16.1 10.93-.95.65-14.52 9.87-5.86 3.99-.64.43-2.47-1.7-3.93-2.72-4.14-2.86-7.9-5.45-2.23-1.54-17.24-11.89-16.85-11.64M61.29 56.51H43.6V39.84a8.85 8.85 0 0117.69 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M52.68 31.12h75.79a8.74 8.74 0 018.86 8.55v25.69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M107.68 62.81s-1.51-8.75-8.76-8.75-9.18 8.75-9.18 8.75l18.8 14.26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M90.6 77.07s1.52 8.75 8.76 8.75 9.18-8.75 9.18-8.75M99.14 46.6v7.46M99.14 85.82v7.46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M107.68 62.81s-1.51-8.75-8.76-8.75-9.18 8.75-9.18 8.75l18.8 14.26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M90.6 77.07s1.52 8.75 8.76 8.75 9.18-8.75 9.18-8.75M99.14 46.6v7.46M99.14 85.82v7.46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProformaInvoicesReceived);
export default __webpack_public_path__ + "static/media/proformaInvoicesReceived.edd3a741a83dec8cee5a953358dfac60.svg";
export { ForwardRef as ReactComponent };